import { useQuery } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';

export interface OnboardingState {
  lastCompletedStep?: number;
  onboardingSkipped?: boolean;
  skipped?: boolean;
  step1_experience?: string | string[];
  step2_client_types?: string[];
  step3_offers?: string[];
  step4_schedule?: {
    timezone: string;
    weekly_schedule?: any;
  };
}

export interface OnboardingStateResult {
  onboarding: OnboardingState;
  profile?: Record<string, unknown> & {
    onboarding?: OnboardingState;
  };
}

import { sessionStore } from 'src/store/sessionStore';

export const fetchOnboardingState = async (uid: string) => {
  const apiUrl = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_GET_ONBOARDING_STATE}?uid=${uid}`;
  const response = await fetch(apiUrl);

  if (!response.ok) {
    if (response.status === 404) {
      return { onboarding: {} as OnboardingState, profile: {} };
    }
    throw new Error('Failed to fetch onboarding state');
  }

  const res = await response.json();

  // Automatically sync the user profile into the global sessionStore
  if (res.profile) {
    const currentToken = sessionStore.getState().token;
    if (currentToken) {
      sessionStore.getState().setToken(currentToken, {
        ...res.profile,
        uid: res.profile.uid || uid,
      });
    }
  }

  return {
    onboarding: (res.data || {}) as OnboardingState,
    profile: res.profile || {},
  };
};

export function useGetOnboardingState(uid?: string) {
  return useQuery({
    queryKey: ['onboarding-state', uid],
    queryFn: async () => {
      if (!uid) return null;
      return fetchOnboardingState(uid);
    },
    enabled: !!uid,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
